import ResumeItem from "@/common/components/ResumeItem";
import { checkinEntryOptions } from "@/features/maintenance/features/workflows/constants/forwardings/steps/checkinEntry/checkinEntryOptions.constant";
import { useForwardingTabContext } from "@/features/maintenance/features/workflows/hooks/forwardings/useForwardingTabContext";
import { MaintenanceForwardingDirectiveEntryStatus } from "@/features/maintenance/features/workflows/types/forwardings/maintenanceForwarding.type";
import { MaintenanceForwardingsDirectiveEntryKlass } from "@/features/maintenance/features/workflows/types/forwardings/maintenanceForwardingsDirectiveEntryKlasses.type";
import { useMemo } from "react";
import ExecutionObjectiveItem from "./ExecutionObjectiveItem";

const DirectiveEntryExecutionEntryExecution = () => {
  const {
    forwarding,
    forwardingUpdatedAt,
  } = useForwardingTabContext<MaintenanceForwardingsDirectiveEntryKlass.ExecutionEntry>();

  const isInProgress = useMemo(() => {
    return forwarding.directive_entry.status === MaintenanceForwardingDirectiveEntryStatus.InProgress;
  }, [forwardingUpdatedAt]);

  return (
    <>
      <div className="flex flex-col gap-3">
        <div className="flex gap-3">
          {forwarding.checkin_entry_type && (
            <ResumeItem
              label="Tipo de transporte"
              value={checkinEntryOptions[forwarding.checkin_entry_type].title}
              className="text-xs"
              valueClassName="font-bold text-sm"
            />
          )}

          {forwarding.checkin_entry.responsible && (
            <ResumeItem
              label="Responsável por Transporte"
              value={forwarding.checkin_entry?.responsible.full_name || '--'}
              className="text-xs"
              valueClassName="font-bold text-sm"
            />
          )}
        </div>
      </div>

      <div className="flex flex-col gap-2">
        <p className="font-bold">
          Checklist da manutenção
        </p>

        <div className="flex flex-col gap-1.5">
          {forwarding?.directive_entry?.objectives?.map((objective) => (
            <ExecutionObjectiveItem
              key={objective.id}
              objective={objective}
              isInProgress={isInProgress}
            />
          ))}
        </div>
      </div>
    </>
  );
}

export default DirectiveEntryExecutionEntryExecution;
